import type { CasegoodsInventoryItem, OrgInventoryItem } from '../types/admin';

// ── Add-equipment helper (shared by the Casegoods Inventory and Materials pages) ──

/**
 * Given an inventory list and the old/new quantity of a specific item,
 * applies the item's addEquipment entries using ceil on total quantities.
 * Equipment qty = ceil(rate × newQty) - ceil(rate × oldQty).
 */
export function applyAddEquipment(
  inv: CasegoodsInventoryItem[],
  mainItemId: string,
  oldQty: number,
  newQty: number,
  orgItems: OrgInventoryItem[],
): CasegoodsInventoryItem[] {
  if (oldQty === newQty) return inv;
  const orgItem = orgItems.find(i => i.id === mainItemId);
  if (!orgItem?.addEquipment?.length) return inv;

  let result = [...inv];
  for (const eq of orgItem.addEquipment) {
    const oldEq = oldQty <= 0 ? 0 : Math.ceil(eq.quantity * oldQty);
    const newEq = newQty <= 0 ? 0 : Math.ceil(eq.quantity * newQty);
    const qtyDelta = newEq - oldEq;
    if (qtyDelta === 0) continue;

    const idx = result.findIndex(i => i.itemId === eq.itemId);
    if (idx >= 0) {
      const updatedQty = result[idx].quantity + qtyDelta;
      if (updatedQty <= 0) {
        result = result.filter((_, i) => i !== idx);
      } else {
        result = result.map((item, i) =>
          i === idx ? { ...item, quantity: updatedQty } : item,
        );
      }
    } else if (qtyDelta > 0) {
      const eqOrgItem = orgItems.find(i => i.id === eq.itemId);
      result = [...result, {
        itemId: eq.itemId,
        itemName: eq.itemName,
        quantity: qtyDelta,
        itemCategory: eqOrgItem?.residentialType ?? 'equipment',
      }];
    }
  }
  return result;
}

